'use strict';

var tslib = require('tslib');
var React = require('react');
var index = require('./index-914929f8.js');
var require$$2 = require('react/jsx-runtime');
require('events');
require('@emotion/react');
require('react-intl');
require('react-dom');
require('react-hook-form');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

function getFormGroupUtilityClass(slot) {
  return index.generateUtilityClass('MuiFormGroup', slot);
}
index.generateUtilityClasses('MuiFormGroup', ['root', 'row', 'error']);

const _excluded$1 = ["className", "row"];
const useUtilityClasses$1 = ownerState => {
  const {
    classes,
    row,
    error
  } = ownerState;
  const slots = {
    root: ['root', row && 'row', error && 'error']
  };
  return index.composeClasses(slots, getFormGroupUtilityClass, classes);
};
const FormGroupRoot = index.styled('div', {
  name: 'MuiFormGroup',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.row && styles.row];
  }
})(({
  ownerState
}) => index._extends({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap'
}, ownerState.row && {
  flexDirection: 'row'
}));

/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */
const FormGroup = /*#__PURE__*/React__namespace.forwardRef(function FormGroup(inProps, ref) {
  const props = index.useThemeProps({
    props: inProps,
    name: 'MuiFormGroup'
  });
  const {
      className,
      row = false
    } = props,
    other = index._objectWithoutPropertiesLoose(props, _excluded$1);
  const muiFormControl = index.useFormControl();
  const fcs = index.formControlState({
    props,
    muiFormControl,
    states: ['error']
  });
  const ownerState = index._extends({}, props, {
    row,
    error: fcs.error
  });
  const classes = useUtilityClasses$1(ownerState);
  return /*#__PURE__*/require$$2.jsx(FormGroupRoot, index._extends({
    className: index.clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? FormGroup.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: index.PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: index.PropTypes.object,
  /**
   * @ignore
   */
  className: index.PropTypes.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: index.PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: index.PropTypes.oneOfType([index.PropTypes.arrayOf(index.PropTypes.oneOfType([index.PropTypes.func, index.PropTypes.object, index.PropTypes.bool])), index.PropTypes.func, index.PropTypes.object])
} : void 0;
var FormGroup$1 = FormGroup;

function getRadioGroupUtilityClass(slot) {
  return index.generateUtilityClass('MuiRadioGroup', slot);
}
index.generateUtilityClasses('MuiRadioGroup', ['root', 'row', 'error']);

const _excluded = ["actions", "children", "className", "defaultValue", "name", "onChange", "value"];
const useUtilityClasses = props => {
  const {
    classes,
    row,
    error
  } = props;
  const slots = {
    root: ['root', row && 'row', error && 'error']
  };
  return index.composeClasses(slots, getRadioGroupUtilityClass, classes);
};
const RadioGroup$1 = /*#__PURE__*/React__namespace.forwardRef(function RadioGroup(props, ref) {
  const {
      // private
      // eslint-disable-next-line react/prop-types
      actions,
      children,
      className,
      defaultValue,
      name: nameProp,
      onChange,
      value: valueProp
    } = props,
    other = index._objectWithoutPropertiesLoose(props, _excluded);
  const rootRef = React__namespace.useRef(null);
  const classes = useUtilityClasses(props);
  const [value, setValueState] = index.useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'RadioGroup'
  });
  React__namespace.useImperativeHandle(actions, () => ({
    focus: () => {
      let input = rootRef.current.querySelector('input:not(:disabled):checked');
      if (!input) {
        input = rootRef.current.querySelector('input:not(:disabled)');
      }
      if (input) {
        input.focus();
      }
    }
  }), []);
  const handleRef = index.useForkRef(ref, rootRef);
  const name = index.useId(nameProp);
  const contextValue = React__namespace.useMemo(() => ({
    name,
    onChange(event) {
      setValueState(event.target.value);
      if (onChange) {
        onChange(event, event.target.value);
      }
    },
    value
  }), [name, onChange, setValueState, value]);
  return /*#__PURE__*/require$$2.jsx(index.RadioGroupContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/require$$2.jsx(FormGroup$1, index._extends({
      role: "radiogroup",
      ref: handleRef,
      className: index.clsx(classes.root, className)
    }, other, {
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? RadioGroup$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: index.PropTypes.node,
  /**
   * @ignore
   */
  className: index.PropTypes.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: index.PropTypes.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: index.PropTypes.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: index.PropTypes.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: index.PropTypes.any
} : void 0;
var MuiRadioGroup = RadioGroup$1;

/** https://mui.com/components/radio-buttons/ */
const RadioGroup = React.forwardRef((_a, ref) => {
    var { InputLabelProps, HelperTextProps, FormControlProps, disabled, error, focused, helperText, id, items, label, name, value, options, required } = _a, props = tslib.__rest(_a, ["InputLabelProps", "HelperTextProps", "FormControlProps", "disabled", "error", "focused", "helperText", "id", "items", "label", "name", "value", "options", "required"]);
    const inputId = id !== null && id !== void 0 ? id : `${name}_input`;
    const labelId = `${name}_label`;
    const helperTextId = `${name}_helperText`;
    return (React.createElement(index.MultiThemeProvider, null, (themeName) => (React.createElement(index.MuiFormControl, Object.assign({}, FormControlProps),
        label && (React.createElement(index.InputLabel, Object.assign({}, InputLabelProps, { id: labelId, error: error, focused: focused, disabled: disabled, required: required, htmlFor: inputId, readOnly: props.readOnly }), label)),
        React.createElement(MuiRadioGroup, Object.assign({}, props, { ref: ref, value: value, "aria-describedby": helperTextId, "aria-labelledby": labelId }), (options || items || []).map((radioItem, idx) => {
            var _a;
            const isDisabled = radioItem.disabled || disabled;
            return (React.createElement(index.FormControlLabel, { key: idx, checked: radioItem.checked || value === radioItem.value, value: (_a = radioItem.value) !== null && _a !== void 0 ? _a : value, disabled: isDisabled, control: React.createElement(index.Radio, Object.assign({}, radioItem, { disabled: isDisabled })), label: radioItem.label, sx: radioItem.sx }));
        })),
        React.createElement(index.FormHelperText, Object.assign({}, HelperTextProps, { id: helperTextId, "data-testid": 'helperText', disabled: disabled, error: error, required: required }), index.determineHelperText({ themeName, required, helperText }))))));
});
RadioGroup.displayName = 'RadioGroup';
RadioGroup.defaultProps = {
    color: 'primary',
    items: [],
};

exports.default = RadioGroup;
